import { jwtDecode } from 'jwt-decode';

export interface JWTUser {
  sub: string;
  iat: number;
  exp: number;
  [key: string]: unknown;
}

const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const getCurrentJWTUser = (): JWTUser | undefined => {
  const token = getToken();
  if (!token) return;

  try {
    const decoded = jwtDecode<JWTUser>(token);

    const now = Math.floor(Date.now() / 1000);
    if (decoded.exp && decoded.exp < now) {
      logout();
      return;
    }

    return decoded;
  } catch (err) {
    console.error('Invalid token:', err);
    logout();
    return;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
};
